import { type Ref } from 'vue'
import { lazyRef } from '../../utils/LazyRef'

type LazyStore<TModel> = {
  list: Ref<TModel[]>
  load: () => Promise<TModel[]>
  reload: () => Promise<TModel[]>
  isLoaded: Ref<boolean>
  isLoading: Ref<boolean>
}

type Loader<T> = () => Promise<T>

/**
 * Lazy store composable that loads data on first access
 */
export const useLazyStore = <TModel>(loader: Loader<TModel[]>): LazyStore<TModel> => {
  const list = lazyRef(loader, [])

  return {
    list,
    load: list.load,
    reload: list.reload,
    isLoaded: list.isLoaded,
    isLoading: list.isLoading,
  }
}
